import { ReactNode } from "react";
import { usePermission } from "./usePermission";

interface PermissionGateProps {
  application: string;
  feature: string;
  category: string;
  children: ReactNode;
  /**   to render when the permission check fails. Defaults to nothing. */
  fallback?: ReactNode;
}


export function PermissionGate({
  application,
  feature,
  category,
  children,
  fallback = null,
}: PermissionGateProps) {
  const allowed = usePermission(application, feature, category);
  return <>{allowed ? children : fallback}</>;
}
